export namespace TCryptoJS {
  export const USER_SERVER_IV = 'a0fe7c7c98e09e8c'; // 用户服务端加密IV

  export const MEET_CLIENT_IV = 'a0fe7c7c98e09e8c'; // 会议前端的加密IV

  export const MEET_SERVER_IV = 'e1cd3df9a4c14618'; // 会议服务端的加密IV

  export type Iv = typeof USER_SERVER_IV | typeof MEET_CLIENT_IV | typeof MEET_SERVER_IV;
}
